import './App.css';
import Header from "./components/header"
import Meme from "./components/meme"

function App() {
  return (
    <div className="App">
      <Header />
      <Meme />
    </div>
  );
}

export default App;
